<template>
  <input type="text" v-bind:value="color">
</template>

<script>
/* global jQuery */
require('../../libs/spectrum');

export default {
  props: {
    color: {
      required: true,
    },
  },

  watch: {
    color() {
      jQuery(this.$el).spectrum('set', this.color);
    },

    parent(newVal, oldVal) {
      if (newVal !== oldVal) {
        jQuery(this.$el).spectrum('destroy');
        this.loadPicker();
      }
    },
  },

  methods: {
    loadPicker() {
      const { color } = this;

      jQuery(this.$el).spectrum({
        color,
        preferredFormat: 'hex3',
        showInitial: true,
        showInput: true,
        showAlpha: true,
        change: (c) => {
          if (c) {
            this.$emit('change', c.toRgbString());
          } else {
            this.$emit('change', '');
          }
        },
      });
    },
  },
  mounted() {
    this.loadPicker();
  },
  destroyed() {
    jQuery(this.$el).spectrum('destroy');
  },
};
</script>
